export default __webpack_public_path__ + "static/media/6t.280ee457.jpg";